/**
 * Which form a French sentence takes about somebody.
 *
 * French agrees, and the application was written as though every member were a
 * woman: « Abonnée », « tu seras prévenue ». Most members are, which is why
 * nobody noticed, but a man reads a sentence that is wrong about him, and
 * somebody who never said their gender reads a guess.
 *
 * THE RULE, set by Maude on 22 September 2026: feminine for a woman, masculine
 * for a man, and a sentence that agrees with nobody when the profile does not
 * say. The third form is not the masculine as a fallback.
 *
 * WHOSE PROFILE IS READ. The reader's own: it is the one gender the
 * application knows. What a sentence says about ANOTHER member is written so
 * the question does not arise, because the member page does not carry their
 * gender and putting it on the wire is not a thing to do for a word.
 *
 * TWO EXCEPTIONS, both of 20 October 2026. The organiser rank on a member
 * page is that member's name, « Meneuse » or « Meneur », gendered by THEIR
 * profile: the API sends that one form, with the rank and only for the three
 * names that agree (`the-rank-on-a-member-page.ts`). And the line of a member
 * says « Pas encore notée » or « Pas encore noté » in their form, which the
 * API sends only while a side has no score (`what-a-profile-line-says.ts`).
 * Maude accepted that another member's form shows, for the rank chip; each
 * reveals what its words show and nothing else.
 *
 * The same rule lives on the API side in how-somebody-is-addressed.ts, for the
 * sentences the server writes.
 */
export type Addressed = 'female' | 'male' | 'neutral';

export const howToAddress = (profile?: { sex?: string }): Addressed => {
  const said = profile?.sex?.trim().toLowerCase();
  if (said === 'female') {
    return 'female';
  }
  if (said === 'male') {
    return 'male';
  }
  return 'neutral';
};

/** The key of a text that has one form per reader, « MEMBER_PAGE.FOLLOWING » becoming « ..._FEMALE ». */
export const keyFor = (base: string, form: Addressed): string => `${base}_${form.toUpperCase()}`;
